<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2 class="mr-4">Отчёт по комплексам</h2>
          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              class="mx-3"
              v-model="day"
              label="Выберите дату"
              prepend-icon="event"
              readonly
              v-on="on"
              hide-details
              style="max-width: 140px"
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction"
              v-model="day"
              locale="ru"
              first-day-of-week="1"
              width="300"
              landscape
              type="date"
            >
            </v-date-picker>
          </v-menu>
          <v-select
              v-if="cafes.length > 1"
              :items="cafes"
              v-model="cafe"
              item-text="title"
              item-value="cafeid"
              return-object
              label="Выберите столовую"
              style="max-width: 200px"
              hide-details
              class="mx-3"
              dense
              :disabled="inAction">
          </v-select>
          <v-btn
            class="mx-3"
            color="primary"
            :disabled="!day || !cafe || inAction"
            @click="fetchReport()"
          >
            Загрузить отчёт
          </v-btn>
          <v-btn
            v-if="reportLoaded && report.length > 0"
            text
            color="primary"
            class="mx-3"
            @click="openPdfReport()"
          ><v-icon>save</v-icon></v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card v-if="report">
            <v-card-text id="printableArea">
              <table
                v-if="report && report.length > 0 && inAction === false"
                width="100%"
                border="1"
                cellpadding="0"
                cellspacing="0"
                style="font-size:8pt;border-collapse:collapse;"
              >
                <tr>
                  <th colspan="5">Отчет в разрезе типов питания за {{this.day}}</th>
                </tr>
                <tr>
                  <th>Столовая</th>
                  <th>Тип питания</th>
                  <th>Стоимость комплекса</th>
                  <th>Количество заявок</th>
                  <th>Итого</th>
                </tr>
                <tr v-for="item in report" :key="item.saleypeid">
                  <td>{{item.cafe}}</td>
                  <td>{{item.saletype}}</td>
                  <td align="center">{{rubles(item.amount)}}  &#8381;</td>
                  <td align="center">{{item.requests}}</td>
                  <td align="center">{{parseFloat(item.requests * rubles(item.amount)).toFixed(2)}} &#8381;</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td align="center">{{report.reduce((a ,b) => a + parseInt(b.requests), 0)}}</td>
                  <td align="center">{{rubles(report.reduce((a, b) => a + parseInt(b.amount * b.requests), 0)).toString().replace('.', ',')}}</td>
                </tr>
              </table>
              <table v-else width="100%">
                <tr>
                  <th align="center">Нет данных</th>
                </tr>
              </table>
              <br>
              <small>Дата составления: {{ today }}</small>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ComplexesReport',
  data: () => ({
    day: moment().format('YYYY-MM-DD'),
    reportLoaded: false,
    printContents: '',
    report: null,
    cafe: null,
    cafes: [],
    inAction: false,
    csv: ''
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    today () {
      return moment().format('DD.MM.YYYY')
    }
  },
  methods: {
    async prefetch () {
      try {
        const { cafes } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-cafes'
        })
        this.cafes = Array.isArray(cafes) ? cafes : []
        const selectedCafe = this.cafe &&
          this.cafes.find(cafe => cafe.cafeid === this.cafe.cafeid)
        this.cafe = this.cafes.length === 1 ? this.cafes[0] : (selectedCafe || null)
        // await this.fetchReport()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async fetchReport () {
      if (!this.cafe) return
      try {
        this.reportLoaded = false
        this.inAction = true
        await this.asyncTimeout(500)
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'complexes-report',
          pl: {
            day: this.day,
            cafeid: this.cafe.cafeid,
            orgid: this.cafe.orgid
          }
        })
        this.report = report
        this.reportLoaded = true
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    async openPdfReport () {
      const cssResponse = await fetch('/print-report.css')
      const cssText = await cssResponse.text()
      const html = `
        <html>
          <head>
            <style>${cssText}</style>
          </head>
          <body>
            ${document.getElementById('printableArea').innerHTML}
          </body>
        </html>
      `
      try {
        const { meta, data } = await this.$store.dispatch('sioRequest', {
          topic: 'generate-pdf',
          pl: {
            html: html
          }
        })
        console.log(meta)
        this.$store.dispatch('snack', meta)
        const pdfBlob = new Blob([data], { type: 'application/pdf' })
        const pdfUrl = URL.createObjectURL(pdfBlob)
        window.open(pdfUrl, '_blank')
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
  },
  watch: {
    day () {
      this.report = null
      this.inAction = false
      this.reportLoaded = false
    },
    profile (val) {
      this.prefetch()
    },
    cafe () {
      this.report = null
      this.reportLoaded = false
    },
  },
  mounted () {
    if (this.profile) this.prefetch()
  }
}
</script>
